<template>
    <AdaptersOverlayPanel
        :base-z-index="100001"
        :hover-usage="true"
        :listener-id="listenerId"
        ref="overlayPanel"
        :pt="{
            content: {class: 'p-0'},
            root: {class: 'menu_base_submenu__overlay'}
        }"
    >
        <div class="menu_base_submenu__content">
            <slot></slot>
        </div>
    </AdaptersOverlayPanel>
</template>

<script>
import AdaptersOverlayPanel from "keysso/component/adapters/OverlayPanel.vue";

export default {
    name: "MenuBaseSubmenu",
    props: {
        listenerId: {
            type: String,
            required: true,
        }
    },
    components: {
        AdaptersOverlayPanel,
    },
}
</script>

<style scoped>
.menu_base_submenu__content {
    display: flex;
    flex-direction: column;
    background-color: #465461;
    min-width: 240px;
    max-height: 75vh;
    overflow: auto;
}
.menu_base_submenu__content :deep(a) {
    display: flex;
    align-items: center;
    padding: 16px 22px;
    gap: 8px;
    text-decoration: none;
}
.menu_base_submenu__content :deep(i) {
    font-size: 18px;
    color: #A4B1BE;
}
.menu_base_submenu__content :deep(span) {
    font-size: 13px;
    color: #A4B1BE;
}
/* hover */
.menu_base_submenu__content :deep(a),
.menu_base_submenu__content :deep(a span),
.menu_base_submenu__content :deep(a i) {
    transition: all .3s;
}
.menu_base_submenu__content :deep(a:hover) {
    background-color: #556275;
}
.menu_base_submenu__content :deep(a:hover span),
.menu_base_submenu__content :deep(a:hover i) {
    color: #fff;
}
/* active */
.menu_base_submenu__content :deep(a.active) {
    background-color: #4b5a71;
}
.menu_base_submenu__content :deep(a.active span),
.menu_base_submenu__content :deep(a.active i) {
    color: #fff;
}
.menu_base_submenu__content :deep(.p-divider) {
    margin: 0;
}
.menu_base_submenu__content :deep(.p-divider):before {
    border-top: 1px solid #6c757d !important;
}

/* оформление указателей new, beta */
.menu_base_submenu__content :deep(.top_menu__item_new):after {
    content: 'новое';
    background-color: #70b319;
}
.menu_base_submenu__content :deep(.top_menu__item_beta):after {
    content: 'бета';
    background: orange;
}
.menu_base_submenu__content :deep(.top_menu__item_new):after,
.menu_base_submenu__content :deep(.top_menu__item_beta):after {
    border-radius: 2px;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .1px;
    line-height: 1;
    padding: 1px 4px;
}
</style>

<style>
.menu_base_submenu__overlay:before {
    content: none;
}
.menu_base_submenu__overlay:after {
    border-bottom-color: #465461 !important;
}
</style>
